import axios from 'axios';
import { TOKEN_KEY } from './authToken';
import { expiredAuthQueryFromMessage, invalidateAuthSession, isPublicAuthRequestUrl } from './authSession';
import { AUTH_RATE_LIMIT_ERROR_CODE, AUTH_RATE_LIMIT_FALLBACK_SECONDS, createAuthRateLimitError, getAuthCooldownRemaining, matchAuthRateLimitPathFromConfig, setAuthCooldown, } from './authRateLimit';
import { parseRetryAfterSeconds } from './errors';
export const api = axios.create({
    baseURL: '/api',
    headers: { 'Content-Type': 'application/json' },
});
api.interceptors.request.use((config) => {
    const path = matchAuthRateLimitPathFromConfig(config);
    if (path) {
        const remaining = getAuthCooldownRemaining(path);
        if (remaining > 0) {
            throw createAuthRateLimitError(remaining, config);
        }
    }
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (typeof FormData !== 'undefined' && config.data instanceof FormData && config.headers) {
        const headers = config.headers;
        if (typeof headers.delete === 'function')
            headers.delete('Content-Type');
        else
            Reflect.deleteProperty(config.headers, 'Content-Type');
    }
    return config;
});
api.interceptors.response.use((response) => response, (error) => {
    if (error?.code !== AUTH_RATE_LIMIT_ERROR_CODE) {
        const path = matchAuthRateLimitPathFromConfig(error?.config);
        if (path && error.response?.status === 429) {
            setAuthCooldown(path, parseRetryAfterSeconds(error, AUTH_RATE_LIMIT_FALLBACK_SECONDS));
        }
    }
    if (error.response?.status === 401) {
        const url = String(error.config?.url ?? '');
        if (!isPublicAuthRequestUrl(url) && localStorage.getItem(TOKEN_KEY)) {
            const message = typeof error.response?.data?.message === 'string' ? error.response.data.message : undefined;
            const query = expiredAuthQueryFromMessage(message);
            invalidateAuthSession(query ? { query } : undefined);
        }
    }
    return Promise.reject(error);
});
